module.exports = __webpack_public_path__ + "img/haijunlan.012ae865.png";